module.exports = __webpack_public_path__ + "img/empty.3684b660.webp";